import { useEffect, useState } from "react";
import { siteConfig } from "../config/site";

const links = [
  { label: "EP", href: "#ep" },
  { label: "Sencillo", href: "#single" },
  { label: "Sobre mí", href: "#about" },
  { label: "Videos", href: "#videos" },
  { label: "Galería", href: "#gallery" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div
        className={`mx-auto max-w-6xl px-5 sm:px-8 flex items-center justify-between rounded-full transition-all duration-500 ${
          scrolled ? "glass py-2 px-4 sm:px-6" : ""
        }`}
      >
        <a
          href="#top"
          className="font-script text-3xl sm:text-4xl leading-none text-ink"
          style={{ color: "var(--yicel-ink)" }}
          data-testid="nav-logo"
        >
          Yicel<span style={{ color: "#B2A4FF" }}>.</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm tracking-wide text-[color:var(--yicel-muted)] hover:text-[color:var(--yicel-ink)] transition-colors"
              data-testid={`nav-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={siteConfig.ep.spotify}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-cta-listen"
            className="rounded-full bg-[#2D2A32] text-white px-5 py-2.5 text-sm tracking-wide hover:bg-[#B2A4FF] transition-colors"
          >
            Escuchar
          </a>
        </nav>

        <button
          type="button"
          aria-label="Abrir menú"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden rounded-full p-2 text-[color:var(--yicel-ink)]"
          data-testid="nav-mobile-toggle"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {open ? (
              <>
                <line x1="5" y1="5" x2="19" y2="19" />
                <line x1="19" y1="5" x2="5" y2="19" />
              </>
            ) : (
              <>
                <line x1="4" y1="8" x2="20" y2="8" />
                <line x1="4" y1="16" x2="20" y2="16" />
              </>
            )}
          </svg>
        </button>
      </div>

      {open && (
        <div className="md:hidden mx-auto max-w-6xl px-5 mt-3">
          <div className="glass rounded-3xl p-5 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm text-[color:var(--yicel-muted)] py-2"
                data-testid={`nav-mobile-${l.href.slice(1)}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={siteConfig.ep.spotify}
              target="_blank"
              rel="noreferrer"
              className="rounded-full bg-[#2D2A32] text-white text-center px-5 py-3 text-sm"
              data-testid="nav-mobile-cta"
            >
              Escuchar ahora
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
